// @ts-nocheck
(function () {
  const templateEl = document.querySelector('[data-template]');
  const isProduct =
    (templateEl && templateEl.dataset.template.includes('product')) ||
    window.location.pathname.includes('/products/');
  if (!isProduct) return;

  // ── 1. Viewing count ────────────────────────────────────────
  function addViewingCount(productId) {
    const hour = new Date().getHours();
    const base = (productId % 14) + 9;
    const variation = Math.floor(Math.abs(Math.sin(hour + productId)) * 6);
    const count = base + variation;
    const el = document.createElement('p');
    el.id = 'drfels-viewing';
    el.innerHTML = `<span class="drfels-viewing-dot"></span>${count} people viewing this right now`;
    const buyBtn =
      document.querySelector('[id*="buy_buttons"]') ||
      document.querySelector('button[name="add"]')?.closest('div');
    if (buyBtn) buyBtn.insertAdjacentElement('beforebegin', el);
  }

  // ── 2. Low stock signal ─────────────────────────────────────
  function addStockSignal(variants) {
    const tracked = variants.filter(v => v.inventory_management === 'shopify' && v.available);
    if (!tracked.length) return;
    const total = tracked.reduce((sum, v) => sum + (v.inventory_quantity || 0), 0);
    if (total >= 10 || total <= 0) return;
    const el = document.createElement('p');
    el.id = 'drfels-stock';
    el.innerHTML = total <= 4
      ? `⚠ Only ${total} left in stock — order soon`
      : `🔥 Low stock — only ${total} remaining`;
    const buyBtn = document.querySelector('[id*="buy_buttons"]');
    if (buyBtn) buyBtn.insertAdjacentElement('beforebegin', el);
  }

  // ── Quantity helper ─────────────────────────────────────────
  function setQuantity(qty) {
    const input = /** @type {HTMLInputElement|null} */ (
      document.querySelector('component-quantity-selector [ref="quantityInput"]') ||
      document.querySelector('input[name="quantity"]')
    );
    if (!input) return;
    const setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value')?.set;
    if (setter) setter.call(input, qty);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // ── Find smallest element matching test ─────────────────────
  // Reading .textContent serializes an element's whole subtree, so scanning
  // document.querySelectorAll('*') is a long, uninterruptible task. `root`
  // narrows the scan to the buy-button area; omit it for the (expensive)
  // document-wide scan, which is now only used as a one-shot last resort.
  function findTightest(testFn, root) {
    const skip = new Set(['BODY', 'HTML', 'SCRIPT', 'STYLE', 'HEAD', 'NOSCRIPT', 'FORM', 'MAIN', 'SECTION', 'ARTICLE']);
    let best = null;
    function consider(el) {
      if (skip.has(el.tagName)) return;
      if (!testFn(el)) return;
      if (!best || el.textContent.length < best.textContent.length) best = el;
    }
    // The root itself is a candidate — a document-wide scan would have seen it.
    if (root && root.nodeType === 1) consider(root);
    for (const el of (root || document).querySelectorAll('*')) consider(el);
    return best;
  }

  // Likely containers for the Kaching widget, tightest/most specific first.
  function getWidgetSearchRoots() {
    const sels = [
      'kaching-subscriptions-block',
      '[class*="kaching"]',
      '[id*="buy_buttons"]',
      'form[action*="/cart/add"]',
      '.product-form',
    ];
    const roots = [];
    for (const s of sels) {
      let found;
      try { found = document.querySelectorAll(s); } catch (_) { continue; }
      for (const el of found) if (roots.indexOf(el) === -1) roots.push(el);
    }
    return roots;
  }

  // ── 3. Unified purchase options — all three in one mutually exclusive UI ──
  function injectPurchaseOptions(kachingContainer, oneTimeChild, subscribeChild, priceCents, sellingPlanIds, productVariants) {
    if (document.getElementById('drfels-bundle-cards')) return;

    const price1      = priceCents;
    const price2full  = priceCents * 2;
    const price2disc  = Math.round(price2full * 0.95);
    const perBottle2  = Math.round(price2disc / 2);
    const subPrice    = priceCents;

    // Hide BOTH kaching cards — we own the entire UI
    if (oneTimeChild)   oneTimeChild.style.setProperty('display', 'none', 'important');
    if (subscribeChild) subscribeChild.style.setProperty('display', 'none', 'important');

    // Also hide kaching's "Save X% on every delivery" banner if it's a sibling
    if (subscribeChild) {
      let prev = subscribeChild.previousElementSibling;
      while (prev) {
        if (/save \d+%.*delivery/i.test(prev.textContent)) {
          prev.style.setProperty('display', 'none', 'important');
          break;
        }
        prev = prev.previousElementSibling;
      }
    }

    // Tracks which mode is active
    let activeMode = 'onetime';
    window.__drfelsMode = 'onetime';
    let activeFreq = 1; // 1 = every month, 2 = every 2 months

    function getProductForm() {
      return document.querySelector('form[action*="/cart/add"]') ||
             document.querySelector('form[data-type="add-to-cart-form"]') ||
             document.querySelector('form.product-form');
    }

    // Force the correct selling_plan ID directly on the form input
    function forceSellingPlanOnForm(months) {
      const planId = sellingPlanIds[months];
      if (!planId) return;
      const form = getProductForm();
      if (!form) return;
      form.querySelectorAll('[name="selling_plan"]').forEach(el => {
        el.value = planId;
        el.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    function clickOneTime() {
      const radio = oneTimeChild && oneTimeChild.querySelector('input[type="radio"]');
      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        radio.click();
      }
      const form = getProductForm();
      if (form) {
        form.querySelectorAll('[name="selling_plan"]').forEach(el => {
          el.value = '';
          el.removeAttribute('value');
          el.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
    }

    // ── Network-level intercept ─────────────────────────────────
    // These patches are global, but the selling_plan they enforce belongs to the
    // product whose page is open. An upsell / cross-sell / quick-add widget adds
    // a DIFFERENT product through the same /cart/add endpoint: forcing our plan
    // onto it makes Shopify reject the add (silent failure) or subscribes the
    // customer to something they never chose, and stripping selling_plan in
    // one-time mode turns their intended subscription into a one-off charge.
    // So every request is identified first, and anything we cannot positively
    // match to one of THIS product's variants is passed through untouched.
    const ourVariantIds = new Set((productVariants || []).map(function (v) { return String(v && v.id); }));

    // Ids out of a URLSearchParams / FormData body. Covers `id=123` and the
    // `items[0][id]=123` shape some quick-add widgets use.
    function idsFromEntries(p) {
      const out = [];
      p.getAll('id').forEach(function (v) { out.push(v); });
      for (const key of p.keys()) {
        if (/\[id\]$/.test(key)) out.push(p.get(key));
      }
      return out;
    }

    // Ids out of a parsed JSON body: {"id":123} or {"items":[{"id":123}]}.
    function idsFromJson(obj) {
      if (!obj || typeof obj !== 'object') return [];
      if (Array.isArray(obj)) return obj.map(function (it) { return it && it.id; });
      if (Array.isArray(obj.items)) return obj.items.map(function (it) { return it && it.id; });
      return obj.id != null ? [obj.id] : [];
    }

    function parseJsonBody(body) {
      const t = String(body).trim();
      if (t.charAt(0) !== '{' && t.charAt(0) !== '[') return null;
      try { return JSON.parse(t); } catch (_) { return null; }
    }

    // Fail-safe: true ONLY when every id in the body is a variant of this product.
    function isOurAdd(ids) {
      if (!ourVariantIds.size || !ids.length) return false;
      return ids.every(function (id) { return id != null && ourVariantIds.has(String(id)); });
    }

    // Returns the rewritten string body, or null to leave the request alone.
    function rewriteStringBody(body) {
      const json = parseJsonBody(body);
      if (json) {
        if (!isOurAdd(idsFromJson(json))) return null;
        const planId = sellingPlanIds[activeFreq];
        const items = Array.isArray(json) ? json : (Array.isArray(json.items) ? json.items : [json]);
        items.forEach(function (it) {
          if (!it || typeof it !== 'object') return;
          if (activeMode !== 'subscribe') delete it.selling_plan;
          else if (planId) it.selling_plan = planId;
        });
        return JSON.stringify(json);
      }
      let p;
      try { p = new URLSearchParams(body); } catch (_) { return null; }
      if (!isOurAdd(idsFromEntries(p))) return null;
      if (activeMode !== 'subscribe') {
        if (!p.has('selling_plan')) return null;
        p.delete('selling_plan');
      } else {
        // Subscribe mode: enforce the correct selling_plan for chosen frequency
        const planId = sellingPlanIds[activeFreq];
        if (!planId) return null;
        p.set('selling_plan', planId);
      }
      return p.toString();
    }

    // FormData / URLSearchParams are mutated in place, as before.
    function rewriteEntriesBody(body) {
      if (!isOurAdd(idsFromEntries(body))) return;
      if (activeMode !== 'subscribe') {
        body.delete('selling_plan');
      } else {
        const planId = sellingPlanIds[activeFreq];
        if (planId) body.set('selling_plan', planId);
      }
    }

    (function patchCartRequests() {
      const _fetch = window.fetch;
      window.fetch = function(resource, options) {
        const url = typeof resource === 'string' ? resource
          : resource instanceof Request ? resource.url
          : (resource && resource.toString()) || '';
        if (url.includes('/cart/add') && options && options.body) {
          try {
            if (typeof options.body === 'string') {
              const next = rewriteStringBody(options.body);
              if (next !== null) {
                options = Object.assign({}, options);
                options.body = next;
              }
            } else if (options.body instanceof FormData || options.body instanceof URLSearchParams) {
              rewriteEntriesBody(options.body);
            }
          } catch(_) {}
        }
        // Pass resource/options explicitly: reassigning `options` only reached
        // the real fetch through legacy mapped `arguments`, which silently stops
        // working if this file is ever loaded as a module or minified to strict.
        return _fetch.call(this, resource, options);
      };

      // Patch XHR
      const _open = XMLHttpRequest.prototype.open;
      const _send = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function(method, url) {
        this._drfelsUrl = String(url || '');
        return _open.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function(body) {
        if (this._drfelsUrl && this._drfelsUrl.includes('/cart/add') && typeof body === 'string') {
          try {
            // Same guard as the fetch patch: only this product's variants.
            const next = rewriteStringBody(body);
            if (next !== null) body = next;
          } catch(_) {}
        }
        return _send.call(this, body);
      };

      // Patch form submit (fallback)
      document.addEventListener('submit', function(e) {
        const f = /** @type {HTMLFormElement} */ (e.target);
        if (!f || !f.action || !f.action.includes('/cart/add')) return;
        // Same guard as the network patches, in the safe direction: bail only
        // when the form positively identifies a variant that is NOT ours.
        const idEl = f.querySelector('[name="id"]');
        if (ourVariantIds.size && idEl && idEl.value && !ourVariantIds.has(String(idEl.value))) return;
        if (activeMode !== 'subscribe') {
          f.querySelectorAll('[name="selling_plan"]').forEach(function(el) {
            el.disabled = true;
            setTimeout(function() { el.disabled = false; }, 2000);
          });
        } else {
          const planId = sellingPlanIds[activeFreq];
          if (planId) f.querySelectorAll('[name="selling_plan"]').forEach(el => { el.value = planId; });
        }
      }, true);
    })();

    // ── Add-to-cart button capture: last-moment selling_plan enforcement ──
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('button[name="add"], [data-action="add-to-cart"], button[type="submit"]');
      if (!btn) return;
      const form = getProductForm();
      if (!form || !form.contains(btn)) return;
      if (activeMode === 'subscribe') {
        const planId = sellingPlanIds[activeFreq];
        if (planId) {
          form.querySelectorAll('[name="selling_plan"]').forEach(el => { el.value = planId; });
        }
      }
    }, true); // capture phase — runs before Kaching's handler

    // All layout via inline styles — immune to theme CSS resets
    const cBase = 'position:relative;display:flex;align-items:center;gap:14px;padding:18px 16px;background:#fff;border-radius:16px;cursor:pointer;width:100%;box-sizing:border-box;margin-bottom:10px;-webkit-tap-highlight-color:transparent;touch-action:manipulation;font-family:inherit;';
    const cOff  = 'border:1.5px solid #e0e0e0;';
    const cOn   = 'border:2px solid #1a1a1a;';
    const radB  = 'width:22px;height:22px;min-width:22px;border-radius:50%;display:flex;align-items:center;justify-content:center;background:#fff;flex-shrink:0;';
    const radOff= 'border:2px solid #d0d0d0;';
    const radOn = 'border:2px solid #1a1a1a;';
    const dotB  = 'width:12px;height:12px;border-radius:50%;background:#1a1a1a;transition:opacity 0.15s,transform 0.15s;';
    const dotOff= 'opacity:0;transform:scale(0.3);';
    const dotOn = 'opacity:1;transform:scale(1);';
    const inf   = 'display:flex;flex-direction:column;gap:3px;flex:1;min-width:0;';
    const nm    = 'font-size:0.95rem;font-weight:700;color:#1a1a1a;line-height:1.3;margin:0;';
    const sb    = 'font-size:0.8rem;color:#999;line-height:1.4;margin:0;';
    const pc    = 'display:flex;flex-direction:column;align-items:flex-end;flex-shrink:0;gap:2px;';
    const pr    = 'font-size:1.15rem;font-weight:800;color:#1a1a1a;line-height:1.2;margin:0;';
    const cp    = 'font-size:0.8rem;color:#bbb;text-decoration:line-through;margin:0;';
    const ck    = 'display:flex;align-items:center;justify-content:center;width:22px;height:22px;min-width:22px;border-radius:50%;background:#1a1a1a;color:#fff;font-size:0.68rem;font-weight:900;flex-shrink:0;margin-top:1px;';
    const rw    = 'display:flex;align-items:flex-start;gap:10px;font-size:0.82rem;color:#444;line-height:1.5;margin-bottom:10px;';
    const bdg   = 'position:absolute;top:-13px;right:14px;background:#1a1a1a;color:#fff;font-size:0.6rem;font-weight:800;letter-spacing:0.08em;text-transform:uppercase;padding:4px 12px;border-radius:20px;white-space:nowrap;line-height:1.6;';
    const fpBase = 'flex:1;padding:9px 12px;border-radius:100px;font-size:0.82rem;font-weight:600;font-family:inherit;cursor:pointer;text-align:center;border:1.5px solid;line-height:1;display:block;box-sizing:border-box;';
    const fpOn   = fpBase + 'background:#1a1a1a;color:#fff;border-color:#1a1a1a;';
    const fpOff  = fpBase + 'background:#f0f0f0;color:#888;border-color:#e0e0e0;';

    const wrap = document.createElement('div');
    wrap.id = 'drfels-bundle-cards';
    wrap.innerHTML = `
      <p style="font-size:0.68rem;font-weight:700;letter-spacing:0.14em;text-transform:uppercase;color:#999;margin:0 0 10px;">One-time purchase</p>

      <div role="button" tabindex="0" data-mode="onetime" data-qty="1" style="${cBase}${cOn}">
        <div style="${radB}${radOn}"><div class="drfels-rdot" style="${dotB}${dotOn}"></div></div>
        <div style="${inf}">
          <div style="${nm}">Purchase 1 Bottle</div>
          <div style="${sb}">${fmt(price1)} per bottle</div>
        </div>
        <div style="${pc}"><div style="${pr}">${fmt(price1)}</div></div>
      </div>

      <div role="button" tabindex="0" data-mode="onetime" data-qty="2" style="${cBase}${cOff}">
        <div style="${bdg}">BEST VALUE</div>
        <div style="${radB}${radOff}"><div class="drfels-rdot" style="${dotB}${dotOff}"></div></div>
        <div style="${inf}">
          <div style="${nm}">Purchase 2 Bottles</div>
          <div style="${sb}">${fmt(perBottle2)} per bottle — save 5%</div>
        </div>
        <div style="${pc}">
          <div style="${pr}">${fmt(price2disc)}</div>
          <div style="${cp}">${fmt(price2full)}</div>
        </div>
      </div>

      <div style="display:flex;align-items:center;gap:12px;margin:20px 0 14px;">
        <div style="flex:1;height:1px;background:#e0e0e0;"></div>
        <span style="font-size:0.62rem;font-weight:700;letter-spacing:0.12em;text-transform:uppercase;color:#bbb;">or</span>
        <div style="flex:1;height:1px;background:#e0e0e0;"></div>
      </div>
      <p style="font-size:0.68rem;font-weight:700;letter-spacing:0.14em;text-transform:uppercase;color:#999;margin:0 0 10px;">Monthly subscription</p>

      <div style="margin-top:0;">
        <div role="button" tabindex="0" data-mode="subscribe" data-qty="1"
          style="${cBase}${cOff}flex-direction:column;align-items:stretch;border-radius:0 0 16px 16px;margin-bottom:0;gap:0;padding:20px 18px 18px;">
          <div style="${bdg}font-size:0.68rem;font-weight:700;letter-spacing:0.03em;text-transform:none;">Most popular</div>
          <div style="display:flex;align-items:center;gap:14px;width:100%;">
            <div style="${radB}${radOff}"><div class="drfels-rdot" style="${dotB}${dotOff}"></div></div>
            <div style="${nm}font-size:1.05rem;flex:1;">Subscribe</div>
            <div style="${pc}">
              <div style="${pr}">${fmt(subPrice)}</div>
              <div style="font-size:0.78rem;color:#aaa;margin-top:2px;">/ month</div>
            </div>
          </div>
          <div style="display:flex;gap:8px;margin-top:14px;">
            <button id="drfels-freq-1" style="${fpOn}">Every 1 month</button>
            <button id="drfels-freq-2" style="${fpOff}">Every 2 months</button>
          </div>
          <div id="drfels-sub-details" style="margin-top:18px;padding-top:16px;border-top:1px solid #ebebeb;">
            <div style="font-size:0.88rem;font-weight:700;color:#1a1a1a;margin:0 0 12px;">How subscriptions work:</div>
            <div style="${rw}"><span style="${ck}">✓</span><span>Cancel any time from your customer portal</span></div>
            <div style="${rw}"><span style="${ck}">✓</span><span>Automatically charged every <span id="drfels-charge-label">1 month</span></span></div>
            <div style="${rw}margin-bottom:0;"><span style="${ck}">✓</span><span>Delivery: every <span id="drfels-delivery-label">1 month</span></span></div>
          </div>
        </div>
      </div>
    `;

    injectCOACards(kachingContainer);

    // Insert BEFORE kachingContainer so kaching's JS cannot touch our elements
    kachingContainer.insertAdjacentElement('beforebegin', wrap);
    // Move kaching off-screen (NOT display:none) so its JS stays functional
    kachingContainer.style.cssText += ';position:absolute !important;left:-99999px !important;height:1px !important;overflow:hidden !important;pointer-events:none !important;';

    const allCards = wrap.querySelectorAll('[data-mode]');

    // ── Frequency selector ──────────────────────────────────────

    // Search the entire document for Kaching's delivery frequency <select>
    function findFreqSelect() {
      for (const sel of document.querySelectorAll('select')) {
        if (sel.closest('#drfels-bundle-cards')) continue; // never our own widget
        if (sel.options.length >= 2) return sel;
      }
      return null;
    }

    function setFreq(months) {
      activeFreq = months;

      // 1. Try updating Kaching's hidden <select> so its internal state matches
      const sel = findFreqSelect();
      if (sel) {
        const opts = [...sel.options];
        let idx = 0;
        if (months !== 1) {
          // Match by selling_plan ID or by option text containing "2"
          idx = opts.findIndex(o =>
            (sellingPlanIds[2] && o.value == sellingPlanIds[2]) ||
            /2\s*month/i.test(o.text) ||
            /2/.test(o.text)
          );
          if (idx < 0) idx = 1;
        } else {
          idx = opts.findIndex(o =>
            (sellingPlanIds[1] && o.value == sellingPlanIds[1]) ||
            /1\s*month/i.test(o.text)
          );
          if (idx < 0) idx = 0;
        }
        sel.selectedIndex = idx;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        sel.dispatchEvent(new Event('input', { bubbles: true }));
      }

      // 2. Directly force the correct selling_plan on the product form
      if (activeMode === 'subscribe') forceSellingPlanOnForm(months);

      // 3. Update labels
      const freqText = months === 1 ? '1 month' : '2 months';
      const lbl = document.getElementById('drfels-delivery-label');
      if (lbl) lbl.textContent = freqText;
      const chargeLbl = document.getElementById('drfels-charge-label');
      if (chargeLbl) chargeLbl.textContent = freqText;

      // 4. Update pill styles
      const btn1 = document.getElementById('drfels-freq-1');
      const btn2 = document.getElementById('drfels-freq-2');
      if (btn1) btn1.setAttribute('style', months === 1 ? fpOn : fpOff);
      if (btn2) btn2.setAttribute('style', months === 2 ? fpOn : fpOff);
    }

    const freqBtn1 = document.getElementById('drfels-freq-1');
    const freqBtn2 = document.getElementById('drfels-freq-2');
    if (freqBtn1) freqBtn1.addEventListener('click', (e) => { e.stopPropagation(); e.preventDefault(); setFreq(1); });
    if (freqBtn2) freqBtn2.addEventListener('click', (e) => { e.stopPropagation(); e.preventDefault(); setFreq(2); });

    // Find kaching's "Subscription details" widget
    let subWidget = null;
    let subWidgetSearched = false; // cache the miss too — see below
    function scanForSubWidget(root) {
      for (const el of root.querySelectorAll('*')) {
        if (el.childElementCount === 0 && /^\W*subscription details\W*$/i.test(el.textContent.trim())) {
          let node = el;
          for (let i = 0; i < 4; i++) {
            const p = node.parentElement;
            if (!p || p === document.body || p.contains(wrap)) break;
            node = p;
          }
          if (!node.contains(wrap) && node !== el.parentElement || node.childElementCount <= 6) {
            return node;
          }
          return null;
        }
      }
      return null;
    }
    // This used to walk the whole document (reading .textContent on every
    // element) and only cached a hit — a miss meant re-walking on every call,
    // and a single card tap calls setActive three times. Search the Kaching
    // container first, fall back to the document once, then never again.
    function findSubWidget() {
      // A cached miss stays cached; a cached hit is re-searched only if Kaching
      // re-rendered and detached the node we were holding.
      if (subWidgetSearched && (!subWidget || document.contains(subWidget))) return subWidget;
      subWidgetSearched = true;
      subWidget = scanForSubWidget(kachingContainer) || scanForSubWidget(document);
      return subWidget;
    }

    // `restyleOnly` = the +80ms/+300ms re-apply passes: repaint the cards (and
    // the already-known panel) after Kaching re-renders, without searching again.
    function setActive(activeCard, restyleOnly) {
      const isSubscribe = activeCard.dataset.mode === 'subscribe';

      allCards.forEach(card => {
        const on = card === activeCard;
        card.style.border = on ? '2px solid #1a1a1a' : '1.5px solid #e0e0e0';
        const dot = card.querySelector('.drfels-rdot');
        if (dot) {
          dot.style.opacity = on ? '1' : '0';
          dot.style.transform = on ? 'scale(1)' : 'scale(0.3)';
          if (dot.parentElement) dot.parentElement.style.border = on ? '2px solid #1a1a1a' : '2px solid #d0d0d0';
        }
      });

      // Re-apply passes reuse the cached node; only the first pass may search.
      const w = restyleOnly ? subWidget : findSubWidget();
      if (w) w.style.setProperty('display', isSubscribe ? '' : 'none', 'important');
    }

    setActive(allCards[0]);
    clickOneTime();

    allCards.forEach(card => {
      card.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
        setActive(card);
        setTimeout(() => setActive(card, true), 80);
        setTimeout(() => setActive(card, true), 300);
        if (card.dataset.mode === 'subscribe') {
          activeMode = 'subscribe';
          window.__drfelsMode = 'subscribe';
          setQuantity(1);
          const subRadio = subscribeChild && subscribeChild.querySelector('input[type="radio"]');
          if (subRadio) { subRadio.checked = true; subRadio.dispatchEvent(new Event('change', { bubbles: true })); subRadio.click(); }
          // Apply the current frequency selection and force it on the form
          setTimeout(() => setFreq(activeFreq), 200);
          setTimeout(() => forceSellingPlanOnForm(activeFreq), 400);
        } else {
          activeMode = 'onetime';
          window.__drfelsMode = 'onetime';
          setQuantity(Number(card.dataset.qty));
          clickOneTime();
          setTimeout(() => clickOneTime(), 150);
        }
      });
    });
  }

  // ── Price formatter ─────────────────────────────────────────
  function fmt(cents) {
    const d = cents / 100;
    return '$' + (d % 1 === 0 ? d.toFixed(0) : d.toFixed(2));
  }

  // ── Bestseller badge — above the product title on the product page ──
  // On cards this is pinned to the image corner; here it sits in the flow
  // above the title (the #drfels-bestseller-badge rule unpins it).
  function injectBestsellerBadge() {
    if (!window.drfelsIsBestseller) return;
    if (document.getElementById('drfels-bestseller-badge')) return;

    var titleEl =
      document.querySelector('[ref="productTitleLink"]') ||
      document.querySelector('.product-title') ||
      document.querySelector('h1');
    if (!titleEl) return;

    var badge = document.createElement('span');
    badge.id = 'drfels-bestseller-badge';
    badge.className = 'drfels-bestseller-badge';
    badge.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
      '<path d="M12 2l2.9 6.3 6.9.8-5.1 4.7 1.4 6.8L12 17.3 5.9 20.6l1.4-6.8L2.2 9.1l6.9-.8z"/>' +
      '</svg>Bestseller';
    titleEl.insertAdjacentElement('beforebegin', badge);
  }

  // ── Launch badge — under the product title on the product page ──
  function injectLaunchBadge() {
    if (!window.drfelsLaunchText) return;
    if (document.getElementById('drfels-launch-badge')) return;

    // The title link carries a stable ref attribute in this theme.
    var titleEl =
      document.querySelector('[ref="productTitleLink"]') ||
      document.querySelector('.product-title') ||
      document.querySelector('h1');
    if (!titleEl) return;

    var badge = document.createElement('span');
    badge.id = 'drfels-launch-badge';
    badge.className = 'drfels-launch-badge';
    badge.textContent = window.drfelsLaunchText;
    titleEl.insertAdjacentElement('afterend', badge);
  }

  // ── Certificate of Analysis cards (single or combo dropdown) ──
  function injectCOACards(anchor) {
    if (!anchor) return;
    if (document.getElementById('drfels-coa-card') || document.getElementById('drfels-coa-combo')) return;

    if (window.drfelsCOAUrl) {
      const coaCard = document.createElement('a');
      coaCard.id = 'drfels-coa-card';
      const coaMeta = window.drfelsCOAData || { name: 'Dr. Fels Naturals', batch: '', file: 'Certificate-of-Analysis.pdf' };
      coaCard.href = window.drfelsCOAUrl;
      coaCard.download = coaMeta.file;
      coaCard.style.cssText = [
        'display:flex;align-items:center;gap:14px',
        'background:#fff;border:1px solid #e8e8e8;border-radius:14px',
        'padding:16px 18px;margin-bottom:20px',
        'box-shadow:0 1px 4px rgba(0,0,0,0.05)',
        'cursor:pointer;text-decoration:none',
        'transition:box-shadow 0.18s',
      ].join(';');
      coaCard.innerHTML = `
        <div style="width:42px;height:42px;border-radius:10px;background:#edf7f1;border:1px solid #b8dfc9;flex-shrink:0;display:flex;align-items:center;justify-content:center;">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2a7a4b" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="9" y1="13" x2="15" y2="13"/><line x1="9" y1="17" x2="13" y2="17"/>
          </svg>
        </div>
        <div style="flex:1;min-width:0;">
          <div style="font-size:0.62rem;font-weight:700;letter-spacing:0.13em;text-transform:uppercase;color:#999;margin-bottom:3px;">Third-Party Tested</div>
          <div style="font-size:0.92rem;font-weight:700;color:#1a1a1a;line-height:1.3;margin-bottom:2px;">Certificate of Analysis</div>
          <div style="font-size:0.75rem;color:#999;line-height:1.4;">${coaMeta.name} &middot; Batch ${coaMeta.batch}</div>
          <div style="display:inline-flex;align-items:center;gap:4px;font-size:0.7rem;font-weight:600;color:#2a7a4b;margin-top:5px;">
            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            Verified by ${coaMeta.lab || 'Daane Labs &amp; Harken Research'}
          </div>
        </div>
        <div style="flex-shrink:0;width:36px;height:36px;border-radius:8px;background:#1a1a1a;display:flex;align-items:center;justify-content:center;">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>
          </svg>
        </div>
      `;
      coaCard.addEventListener('mouseenter', function() { this.style.boxShadow = '0 3px 12px rgba(0,0,0,0.1)'; });
      coaCard.addEventListener('mouseleave', function() { this.style.boxShadow = '0 1px 4px rgba(0,0,0,0.05)'; });
      anchor.insertAdjacentElement('beforebegin', coaCard);
    }

    if (window.drfelsCOAList && window.drfelsCOAList.length) {
      var coaStyle = document.createElement('style');
      coaStyle.textContent = [
        '#drfels-coa-combo{background:#fff;border:1px solid #e8e8e8;border-radius:14px;padding:16px 18px;margin-bottom:20px;box-shadow:0 1px 4px rgba(0,0,0,0.05);transition:box-shadow 0.18s;}',
        '#drfels-coa-combo:hover{box-shadow:0 3px 12px rgba(0,0,0,0.08);}',
        '#drfels-coa-combo .dcoa-opt:hover{background:#f7f7f5;}',
        '#drfels-coa-combo .dcoa-opt.selected{background:#edf7f1;}',
        '#drfels-coa-combo .dcoa-dl.active:hover{opacity:0.85;transform:translateY(-1px);}',
        '#drfels-coa-combo .dcoa-sel-btn:hover{border-color:#c0c0c0;}',
      ].join('');
      document.head.appendChild(coaStyle);

      var coaCombo = document.createElement('div');
      coaCombo.id = 'drfels-coa-combo';

      var optionsHTML = window.drfelsCOAList.map(function(item, i) {
        return [
          '<div class="dcoa-opt" data-idx="' + i + '" role="option" tabindex="0" style="display:flex;align-items:center;gap:12px;padding:12px 14px;cursor:pointer;transition:background 0.12s;border-bottom:1px solid #e8e8e8;">',
            '<div style="width:32px;height:32px;border-radius:8px;flex-shrink:0;display:flex;align-items:center;justify-content:center;font-size:0.72rem;font-weight:800;color:#fff;background:' + item.color + ';">' + item.abbr + '</div>',
            '<div style="flex:1;min-width:0;">',
              '<div style="font-size:0.83rem;font-weight:700;color:#1a1a1a;line-height:1.2;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + item.name + '</div>',
              '<div style="font-size:0.71rem;color:#999;margin-top:1px;">Code No &middot; ' + item.code + ' &middot; Daane Labs</div>',
            '</div>',
            '<div class="dcoa-check" style="width:18px;height:18px;border-radius:50%;border:2px solid #e8e8e8;flex-shrink:0;display:flex;align-items:center;justify-content:center;transition:background 0.12s,border-color 0.12s;">',
              '<svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" style="opacity:0;transition:opacity 0.12s;"><polyline points="20 6 9 17 4 12"/></svg>',
            '</div>',
          '</div>',
        ].join('');
      }).join('');

      coaCombo.innerHTML = [
        '<div style="display:flex;align-items:center;gap:14px;margin-bottom:14px;">',
          '<div style="width:42px;height:42px;border-radius:10px;background:#edf7f1;border:1px solid #b8dfc9;flex-shrink:0;display:flex;align-items:center;justify-content:center;">',
            '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2a7a4b" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">',
              '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>',
              '<polyline points="14 2 14 8 20 8"/><line x1="9" y1="13" x2="15" y2="13"/><line x1="9" y1="17" x2="13" y2="17"/>',
            '</svg>',
          '</div>',
          '<div style="flex:1;min-width:0;">',
            '<div style="font-size:0.62rem;font-weight:700;letter-spacing:0.13em;text-transform:uppercase;color:#999;margin-bottom:2px;">Third-Party Tested</div>',
            '<div style="font-size:0.93rem;font-weight:700;color:#1a1a1a;line-height:1.2;margin-bottom:3px;">Certificates of Analysis</div>',
            '<div style="display:inline-flex;align-items:center;gap:4px;font-size:0.7rem;font-weight:600;color:#2a7a4b;">',
              '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>',
              'Verified by Daane Labs &amp; Harken Research',
            '</div>',
          '</div>',
        '</div>',
        '<div style="height:1px;background:#e8e8e8;margin-bottom:14px;"></div>',
        '<div style="font-size:0.68rem;font-weight:700;letter-spacing:0.1em;text-transform:uppercase;color:#999;margin-bottom:7px;">Select a certificate to download</div>',
        '<div style="position:relative;margin-bottom:12px;">',
          '<button class="dcoa-sel-btn" style="width:100%;background:#f7f7f5;border:1.5px solid #e8e8e8;border-radius:10px;padding:11px 40px 11px 14px;font-family:inherit;font-size:0.85rem;font-weight:500;color:#999;cursor:pointer;text-align:left;display:flex;align-items:center;gap:10px;transition:border-color 0.15s;position:relative;" aria-haspopup="listbox" aria-expanded="false">',
            '<span class="dcoa-btn-icon" style="width:26px;height:26px;border-radius:6px;flex-shrink:0;display:flex;align-items:center;justify-content:center;font-size:0.72rem;font-weight:800;color:#fff;opacity:0;transition:opacity 0.15s;"></span>',
            '<span class="dcoa-btn-text">Choose a product…</span>',
            '<svg style="position:absolute;right:13px;top:50%;transform:translateY(-50%);transition:transform 0.2s;pointer-events:none;" class="dcoa-chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>',
          '</button>',
          '<div class="dcoa-menu" role="listbox" style="display:none;position:absolute;top:100%;left:0;right:0;background:#fff;border:1.5px solid #1a1a1a;border-top:none;border-bottom-left-radius:10px;border-bottom-right-radius:10px;overflow:hidden;z-index:999;box-shadow:0 6px 20px rgba(0,0,0,0.1);">',
            optionsHTML,
          '</div>',
        '</div>',
        '<a class="dcoa-dl" href="#" style="display:flex;align-items:center;justify-content:center;gap:8px;padding:12px 16px;border-radius:10px;background:#bbb;color:#fff;font-family:inherit;font-size:0.85rem;font-weight:700;text-decoration:none;pointer-events:none;transition:background 0.18s,transform 0.12s;cursor:not-allowed;">',
          '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>',
          'Download Certificate',
        '</a>',
        '<div class="dcoa-hint" style="font-size:0.72rem;color:#999;text-align:center;margin-top:10px;line-height:1.5;">Select a product above to download its certificate.</div>',
      ].join('');

      var selBtn = coaCombo.querySelector('.dcoa-sel-btn');
      var menu    = coaCombo.querySelector('.dcoa-menu');
      var chevron = coaCombo.querySelector('.dcoa-chevron');
      var btnIcon = coaCombo.querySelector('.dcoa-btn-icon');
      var btnText = coaCombo.querySelector('.dcoa-btn-text');
      var dlBtn   = coaCombo.querySelector('.dcoa-dl');
      var hint    = coaCombo.querySelector('.dcoa-hint');

      function openMenu() {
        menu.style.display = 'block';
        selBtn.style.borderColor = '#1a1a1a';
        selBtn.style.borderBottomLeftRadius = '0';
        selBtn.style.borderBottomRightRadius = '0';
        chevron.style.transform = 'translateY(-50%) rotate(180deg)';
        selBtn.setAttribute('aria-expanded', 'true');
      }
      function closeMenu() {
        menu.style.display = 'none';
        selBtn.style.borderColor = '#e8e8e8';
        selBtn.style.borderBottomLeftRadius = '10px';
        selBtn.style.borderBottomRightRadius = '10px';
        chevron.style.transform = 'translateY(-50%)';
        selBtn.setAttribute('aria-expanded', 'false');
      }

      selBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        menu.style.display === 'none' ? openMenu() : closeMenu();
      });

      coaCombo.querySelectorAll('.dcoa-opt').forEach(function(opt) {
        function pick() {
          var idx = parseInt(opt.getAttribute('data-idx'));
          var item = window.drfelsCOAList[idx];
          coaCombo.querySelectorAll('.dcoa-opt').forEach(function(o) {
            o.classList.remove('selected');
            var chk = o.querySelector('.dcoa-check');
            chk.style.background = '';
            chk.style.borderColor = '#e8e8e8';
            chk.querySelector('svg').style.opacity = '0';
          });
          opt.classList.add('selected');
          var myChk = opt.querySelector('.dcoa-check');
          myChk.style.background = '#2a7a4b';
          myChk.style.borderColor = '#2a7a4b';
          myChk.querySelector('svg').style.opacity = '1';
          selBtn.style.color = '#1a1a1a';
          btnIcon.style.opacity = '1';
          btnIcon.style.background = item.color;
          btnIcon.textContent = item.abbr;
          btnText.textContent = item.name;
          dlBtn.classList.add('active');
          dlBtn.href = item.url;
          dlBtn.setAttribute('download', item.file);
          dlBtn.style.background = '#1a1a1a';
          dlBtn.style.pointerEvents = 'auto';
          dlBtn.style.cursor = 'pointer';
          hint.style.display = 'none';
          closeMenu();
        }
        opt.addEventListener('click', pick);
        opt.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); }
        });
      });

      document.addEventListener('click', function(e) {
        if (!coaCombo.contains(e.target)) closeMenu();
      });

      anchor.insertAdjacentElement('beforebegin', coaCombo);
    }
  }

  // ── Fallback anchor for products without Kaching ────────────────
  function findCOAFallbackAnchor() {
    return document.querySelector('[id*="buy_buttons"]') ||
           document.querySelector('button[name="add"]')?.closest('form') ||
           document.querySelector('form[action*="/cart/add"]') ||
           document.querySelector('.product-form');
  }

  // ── Poll until kaching renders ──────────────────────────────
  function pollAndInject(productId, variants, priceCents, sellingPlanIds) {
    let attempts = 0;
    const poll = setInterval(() => {
      attempts++;
      const isFinalAttempt = attempts > 25;

      const matches = el =>
        /one[\s-]?time[\s-]?purchase/i.test(el.textContent) &&
        /subscribe.*save/i.test(el.textContent) &&
        el.children.length >= 2 &&
        el.children.length <= 12;

      // Ticks 1..N-1 only search inside the buy-button area — the document-wide
      // scan on every 400ms tick was the dominant cost behind the page's INP.
      let kachingContainer = null;
      const roots = getWidgetSearchRoots();
      for (const r of roots) {
        kachingContainer = findTightest(matches, r);
        if (kachingContainer) break;
      }
      // Safety net: if the scoped search never found it, fall back to the
      // original document-wide scan ONCE, on the final tick. Without the widget
      // the customer would see Kaching's default UI instead of ours.
      if (!kachingContainer && isFinalAttempt) kachingContainer = findTightest(matches);

      if (kachingContainer) {
        clearInterval(poll);

        let oneTimeChild = null;
        let subscribeChild = null;
        for (const child of kachingContainer.children) {
          const t = child.textContent;
          if (!oneTimeChild && /one[\s-]?time/i.test(t) && !/subscribe/i.test(t)) {
            oneTimeChild = child;
          }
          if (!subscribeChild && /subscribe.*save/i.test(t)) {
            subscribeChild = child;
          }
        }

        injectPurchaseOptions(kachingContainer, oneTimeChild, subscribeChild, priceCents, sellingPlanIds, variants);
        addViewingCount(productId);
        addStockSignal(variants);
        return;
      }

      if (isFinalAttempt) {
        clearInterval(poll);
        injectCOACards(findCOAFallbackAnchor());
        addViewingCount(productId);
        addStockSignal(variants);
      }
    }, 400);
  }

  // ── Init ────────────────────────────────────────────────────
  async function init() {
    const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (!match) return;
    try {
      const res = await fetch('/products/' + match[1] + '.js');
      const product = await res.json();
      const priceCents = (product.variants && product.variants[0])
        ? product.variants[0].price
        : product.price || 0;

      // Extract selling plan IDs from the product data
      const sellingPlanIds = { 1: null, 2: null };
      if (product.selling_plan_groups) {
        for (const group of product.selling_plan_groups) {
          for (const plan of (group.selling_plans || [])) {
            const n = (plan.name || plan.description || '').toLowerCase();
            if (/every 2 month|2.month|bimonth/i.test(n)) {
              sellingPlanIds[2] = String(plan.id);
            } else if (/every 1 month|every month|monthly|1.month/i.test(n)) {
              sellingPlanIds[1] = String(plan.id);
            }
          }
        }
      }

      pollAndInject(product.id, product.variants || [], priceCents, sellingPlanIds);
    } catch (_) {
      pollAndInject(0, [], 0, { 1: null, 2: null });
    }
  }

  // ── FAQ Section Styling ──────────────────────────────────────
  function styleProductFAQ() {
    // Find the FAQ accordion by content rather than by class name
    let faqContainer = null;
    for (const d of document.querySelectorAll('.details')) {
      const hdr = d.querySelector('.details__header');
      if (hdr && /subscription|cancel|skip/i.test(hdr.textContent)) {
        faqContainer = d.closest('.accordion');
        break;
      }
    }
    if (!faqContainer || faqContainer.dataset.drfelsFaqStyled) return;
    faqContainer.dataset.drfelsFaqStyled = '1';

    // Label above the accordion
    const label = document.createElement('div');
    label.className = 'drfels-faq-label';
    label.innerHTML =
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><circle cx="12" cy="17" r="0.5" fill="#999"/></svg>' +
      '<span>Frequently Asked Questions</span>';
    faqContainer.parentElement.insertBefore(label, faqContainer);

    // Apply card styles directly to each element (inline !important beats all theme CSS)
    const rows = faqContainer.querySelectorAll('accordion-custom');
    rows.forEach(function(row, i) {
      const details = row.querySelector('.details');
      if (details) {
        details.style.setProperty('background', '#fff', 'important');
        details.style.setProperty('border', '1px solid #e8e8e8', 'important');
        details.style.setProperty('border-block-start', '1px solid #e8e8e8', 'important');
        details.style.setProperty('border-radius', '12px', 'important');
        details.style.setProperty('padding-left', '20px', 'important');
        details.style.setProperty('padding-right', '20px', 'important');
        details.style.setProperty('margin-bottom', i < rows.length - 1 ? '8px' : '0', 'important');
        details.style.setProperty('box-shadow', '0 1px 4px rgba(0,0,0,0.05)', 'important');
        details.style.setProperty('transition', 'box-shadow 0.18s', 'important');
      }
      const header = row.querySelector('.details__header');
      if (header) {
        header.style.setProperty('padding-top', '18px', 'important');
        header.style.setProperty('padding-bottom', '18px', 'important');
        header.style.setProperty('font-weight', '500', 'important');
        header.style.setProperty('color', '#555', 'important');
        header.style.setProperty('transition', 'color 0.15s', 'important');
      }
      const content = row.querySelector('.details-content');
      if (content) {
        content.style.setProperty('padding-bottom', '18px', 'important');
      }
    });

    // Inject CSS for states that can't be done inline (hover, open, text content)
    if (!document.getElementById('drfels-faq-styles')) {
      const uid = faqContainer.className.match(/accordion--(\S+)/)?.[1] || 'faq';
      const sel = '.accordion[data-drfels-faq-styled="1"]';
      const style = document.createElement('style');
      style.id = 'drfels-faq-styles';
      style.textContent = `
        .drfels-faq-label {
          display:flex;align-items:center;gap:7px;
          font-size:0.68rem;font-weight:700;letter-spacing:0.14em;
          text-transform:uppercase;color:#999;margin-bottom:10px;
        }
        ${sel} accordion-custom .details:hover {
          box-shadow:0 2px 10px rgba(0,0,0,0.09)!important;
        }
        ${sel} accordion-custom .details__header:hover {
          color:#1a1a1a!important;
        }
        ${sel} accordion-custom .details[open]>.details__header {
          color:#1a1a1a!important;font-weight:600!important;
        }
        ${sel} .details-content p {
          margin:0;line-height:1.72;color:#666;font-size:0.93rem;
        }
        ${sel} .details-content strong {
          color:#1a1a1a;font-weight:600;
        }
      `;
      document.head.appendChild(style);
    }
  }

  // Poll until the FAQ accordion is in the DOM.
  // Products with no accordion at all used to burn all 20 ticks (8 seconds of
  // needless main-thread work during the window users first tap). Bail after 3
  // ticks if nothing resembling an accordion has appeared.
  function initFAQ() {
    var attempts = 0;
    var t = setInterval(function() {
      styleProductFAQ();
      var done = document.querySelector('.accordion[data-drfels-faq-styled]');
      if (done || ++attempts > 20) { clearInterval(t); return; }
      if (attempts >= 3 && document.querySelectorAll('.details').length === 0) clearInterval(t);
    }, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      injectBestsellerBadge();
      injectLaunchBadge();
      setTimeout(init, 500);
      initFAQ();
    });
  } else {
    injectBestsellerBadge();
    injectLaunchBadge();
    setTimeout(init, 500);
    initFAQ();
  }
})();
